import React, { ComponentProps, FC } from 'react';
import { Trans } from '@lingui/macro';
import ArrowIcon from '@/assets/icons/arrow.svg';
import useDownload from '@/hooks/useDownload';
import DialogModal from '@/components/Common/DialogModal';
import { Option } from '@/types/utils';
import * as styles from './DownloadDialog.module.scss';

type Props = Omit<ComponentProps<typeof DialogModal>, 'label' | 'title'> & {
  files?: Record<string, string | null> | null;
  sku?: string;
};

const DownloadDialog: FC<Props> = ({ files, sku, ...props }) => {
  const download = useDownload();

  const handleDownload = (url?: string | null) => {
    if (url) {
      download({
        url,
        sku,
      });
    }
  };

  return (
    <DialogModal
      className={styles.dialog}
      label="Download menu"
      title={<Trans>2D/3D Files</Trans>}
      {...props}
    >
      <ul className={styles.files}>
        {(
          Object.entries(files || {}).filter(([_, value]) => value) as Option<string>[]
        ).map(([key, value]) => (
          <li
            key={key}
            className={styles.link}
            role="button"
            onClick={() => handleDownload(value)}
          >
            <ArrowIcon className={styles.arrow} />
            {key}
          </li>
        ))}
      </ul>
    </DialogModal>
  );
};

export default DownloadDialog;
